export default class AuthError {
  code;

  message;

  constructor(code, message) {
    this.code = code
    this.message = message
  }
}
